export default [
    {
        path: 'parametrizacao',
        component: () => import(
            /* webpackChunkName: 'cadastro-parametrizacao' */
            '@/views/cadastro/parametrizacao/Index'
        ),
        redirect: 'parametrizacao/create',
        children: [
            {
                name: 'cadastro-parametrizacao-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'cadastro-parametrizacao' */
                    '@/views/cadastro/parametrizacao/Form.vue'
                ),
            },
        ],
    },
]